export default __webpack_public_path__ + "static/media/caret-right.f72ea08f.svg";